import script from "./acquaint-text-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-text-area.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-text-area.vue?vue&type=style&index=0&id=451feeee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451feeee"]])

export default __exports__